<script lang="ts">
  /* Route, measure, 3D. `ChartTools.svelte` carried a `variant` prop for the
     same reason `Layers` carried `inSheet`; in a panel it is always the list
     with a line of explanation each.

     The single most repeated complaint about the apps this competes with is a
     feature nobody could find — iNavX's verdict was "so many customisations
     that it makes doing the basics too hard", and Navionics hides its charts
     two levels into a menu. A one-line description is the cheapest answer. */
  import ChartTools from '../ChartTools.svelte';
  import { panels } from '@gennetay/chart-ui/shell';
  import { layout } from '@gennetay/chart-ui/shell';
</script>

<ChartTools onpick={() => layout.phone && panels.close('tools')} />
